import React, { useContext } from "react"
import { IStep, PageContents } from "./StrategyExercisePlan"
import { StyledSolutionCardsContainer, StyledSolutionCard, StyledSolutionHeading, StyledFinalCardContainer, StyledPlanNumber, StyledPlanStep, StyledPlantext, StyledDivWithLine, StyledFinalPlanStepContainer, StyledStepHeading, StyledSolutionSubtitle, StyledCTAButtonContainer, StyledCTAButton, StyledPageDescription } from "./StrategyExercisePlan.styled"
import { ThemeContext } from "styled-components";

interface IFinalPageProps extends IStep {
  solution: string,
  planSteps: string[],
  onComplete: () => void
}

const FinalCardContent: React.FC<{ planSteps: string[] }> = ({ planSteps }) => {
  const planStep = (step: string, index: number) => {
    return (
      <StyledPlanStep key={index}>
        <StyledPlanNumber>{index + 1}.</StyledPlanNumber>
        <StyledPlantext>{step}</StyledPlantext>
      </StyledPlanStep>
    )
  } 

  return (
    <StyledFinalCardContainer>

      <StyledStepHeading>Plan the steps</StyledStepHeading>
      {planSteps.map((step, index) => planStep(step, index))}

      <StyledDivWithLine />

      <StyledStepHeading>Final step</StyledStepHeading>
      <StyledFinalPlanStepContainer>
        <StyledPlanNumber>{'!'}</StyledPlanNumber>
        <StyledPlantext>Review your plan. If needed go back and re-look at other solutions.</StyledPlantext>
      </StyledFinalPlanStepContainer>

    </StyledFinalCardContainer>
  )
} 

export const FinalPage: React.FC<IFinalPageProps> = ({ content, solution, planSteps, onComplete }) => {
  const themeContext = useContext(ThemeContext);

  const solutionHeading = () => {
    return (
      <div>
        <StyledSolutionSubtitle>MY PLAN</StyledSolutionSubtitle>
        <StyledSolutionHeading>{solution}</StyledSolutionHeading>
      </div>
    )
  }

  return (
    <React.Fragment>
      <PageContents content={content} onCtaClick={onComplete}>
      <StyledSolutionCardsContainer id="screenshot-zone">
        <StyledSolutionCard
         headerContent={solutionHeading()}
         headerColour={themeContext.colors.chooseCards[1]}
         bodyColour="#fff"
         bodyContent={<FinalCardContent planSteps={planSteps}/>}
        />
      </StyledSolutionCardsContainer>
      </PageContents>
    </React.Fragment>
  )
}